import api from './index';

let exports = {};
//TODO
exports.getShareAccStockList = function (data, callback) {// 擦擦
    api.post('/share/acc/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccStockPageList = function (data, callback) {// 擦擦
    api.post('/share/acc/stock/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getShareAccUseturnVoucherItemList = function (data, callback) {// 擦擦
    api.post('/share/acc/useturn/voucher/item/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getShareAccUseturnVoucherItemListForExport = function (data, callback) {// 擦擦
    api.post('/share/acc/useturn/voucher/item/list/export/do')
    .data(data)
    .done(callback)
    .go();
};
// ================================== 共享配件调配申请单 ==================================
exports.getShareAccAdjustApplyFormById = function (params, callback) {
    api.get('/share/acc/adjust/apply/info/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getShareAccAdjustApplyFormList = function (data, callback) {
    api.post('/share/acc/adjust/apply/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyFormForApply = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/for/apply/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateShareAccAdjustApplyFormForDone = function (data, callback) {
    api.post('/share/acc/adjust/apply/update/for/done/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteShareAccAdjustApplyForm = function (data, callback) {
    api.post('/share/acc/adjust/apply/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccServicerList = function (data, callback) {   // 共享配件服务商
    api.post('/share/acc/servicer/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccWarehouseList = function (data, callback) {   // 共享配件仓库
    api.post('/share/acc/warehouse/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getAdjustApplyFormFileList = function (data, callback) {   // 附件信息
    api.post('/share/acc/adjust/file/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getSpecificAccList = function (data, callback) {   // 根据共享库存信息查询个体化信息
    api.post('/share/acc/specific/acc/list')
    .data(data)
    .done(callback)
    .go();
};

exports.getSpecificAccListByServicerId = function (data, callback) {   // 根据共享库存信息查询个体化信息
    api.post('/share/acc/specific/acc/list/by/servicerId')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShareAccStockNormalQuantity = function (data, callback) {// 修改数量
    api.post('/share/acc/stock/normalQuantity/update/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getShareAccAdujustApplyFormListExportUrl = function (data, callback) {
    api.post('/share/acc/adjust/apply/form/list/export/url/get')
    .data(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shareAcc.js
// module id = 108
// module chunks = 0